import { render } from "./PersonSelectList.vue?vue&type=template&id=4d11d4fa"
import script from "./PersonSelectList.vue?vue&type=script&lang=ts"
export * from "./PersonSelectList.vue?vue&type=script&lang=ts"
script.render = render

export default script